// Analytics service for tracking user interactions
import { session } from './session';
import { apiCall } from './apiService';

const sendToServer = async (data) => {
  try {
    const response = await apiCall('api/log-search', {
      method: 'POST',
      body: JSON.stringify({
        ...data,
        sessionId: session.getSessionId()
      })
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const result = await response.json();
    return result;
  } catch (error) {
    console.error('Error sending analytics data:', error);
  }
};

const logFilterChange = async (filterType, filterName, value) => {
  // Get current timestamp
  const timestamp = new Date().toISOString();
  
  // Create the analytics event
  const event = {
    type: 'filter_change',
    timestamp,
    filterType,
    filterName,
    value: typeof value === 'object' ? JSON.stringify(value) : value
  };

  // Log to console for development
  console.log('Filter Analytics:', event);

  // Send to server
  await sendToServer(event);
};

const logFilterReset = async () => {
  const timestamp = new Date().toISOString();
  
  const event = {
    type: 'filter_reset',
    timestamp
  };

  // Log to console for development
  console.log('Filter Analytics:', event);

  // Send to server
  await sendToServer(event);
};

export const analytics = {
  logFilterChange,
  logFilterReset
}; 